module.exports = __webpack_public_path__ + "media/countdown.03fcdfba.ogg";